import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import PreviousTopups from './PreviousTopups';
import { getPreviousTopupsInitiate } from '../../../actions/company';
import { currentFlowTypeEnum } from '../../common/components/constants';

const mapStateToProps = state => {
  const previousTopupsData = _get(state, 'company.previousTopupsData', []);
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    selectedWorkspace,
    previousTopupsData,
    fetchingPreviousTopups:
      _get(state, 'apiState.GET_PREVIOUS_TOPUPS.isFetching', true) &&
      !_get(state, 'apiState.GET_PREVIOUS_TOPUPS.isIdle', false),
    fetchedPreviousTopups: _get(
      state,
      'apiState.GET_PREVIOUS_TOPUPS.success',
      true,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getPreviousTopups: payload => dispatch(getPreviousTopupsInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreviousTopups);
